import { AuthUser, DB_COLLECTION_NAMES } from "@constants";
import { DocumentActions } from "../firestoreHookTypes";
import { useGetDocument } from "../useGetDocument";

function useGetDbUser(userId: string): [AuthUser | null, DocumentActions] {
  const [user, userActions] = useGetDocument<AuthUser>(
    DB_COLLECTION_NAMES.USERS,
    userId,
  );
  if (user) return [user, userActions];
  return [
    null,
    {
      update: () => Promise.resolve(),
      delete: () => Promise.resolve(),
    },
  ];
}

export { useGetDbUser };
